import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Treatments from "@/pages/Treatments";
import TreatmentDetail from "@/pages/TreatmentDetail";
import Sanctuary from "@/pages/Sanctuary";
import Art from "@/pages/Art";
import ArtworkDetail from "@/pages/ArtworkDetail";
import ArtAbout from "@/pages/ArtAbout";
import Journal from "@/pages/Journal";
import JournalDetail from "@/pages/JournalDetail";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Letter from "@/pages/Letter";
import Breathwork from "@/pages/Breathwork";
import "@/App.css";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/treatments" element={<Treatments />} />
            <Route path="/treatments/:slug" element={<TreatmentDetail />} />
            <Route path="/sanctuary" element={<Sanctuary />} />
            <Route path="/art" element={<Art />} />
            <Route path="/art/about" element={<ArtAbout />} />
            <Route path="/art/:slug" element={<ArtworkDetail />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<Book />} />
            <Route path="/letter" element={<Letter />} />
            <Route path="/breathwork" element={<Breathwork />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}
